import { takeLatest } from 'redux-saga/effects';

import { ON_CODES_MOUNT, ON_CODES_MOUNT_ERROR, REPORTS_DOWNLOAD_DISCOUNT_REPORT } from '../actions';

import { onCodesMount, redirectToHomepage, downloadReport } from './sagas';

export function* onGDCMountWatcher() {
  yield takeLatest(ON_CODES_MOUNT, onCodesMount);
}

export function* redirectToHomepageOnGDCMountError() {
  yield takeLatest(ON_CODES_MOUNT_ERROR, redirectToHomepage);
}

export function* GDCReportDownloadInit() {
  yield takeLatest(REPORTS_DOWNLOAD_DISCOUNT_REPORT, downloadReport);
}



// WEBPACK FOOTER //
// ./src/modules/codes/actions/watchers.js